import React from 'react';
import dayjs from 'dayjs';
import { Box, Link } from '@availity/element';

const currentYear = dayjs().format('YYYY');

const Footer = () => (
  <Box
    p={2}
    style={{
      width: '100%',
      textAlign: 'center',
      marginTop: 'auto',
    }}
  >
    &copy; {currentYear} Availity LLC. All rights reserved.{' '}
    <Link href="https://www.availity.com/Privacy-Policy" target="_blank" loadApp={false}>
      Privacy Policy
    </Link>
  </Box>
);

export default Footer;
